import * as React from 'react';
var Loader = function (_a) {
    var isLoading = _a.isLoading;
    return (React.createElement("div", { className: "spinner-container" + (isLoading ? ' loading' : '') },
        React.createElement("svg", { className: "spinner", viewBox: "0 0 50 50" },
            React.createElement("circle", { className: "path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" }))));
};
export default Loader;
